export const homePageFaqData = [
    {
        id: 1,
        question:
            "How do you collaborate with clients on custom development projects?",
        answer: "We take a collaborative approach, working closely with you to understand your business needs. Whether it's building a blockchain solution or integrating AI, we ensure the final product aligns perfectly with your goals.",
    },
    {
        id: 2,
        question:
            "Do you offer consulting services for blockchain and Web3 projects?",
        answer: "Yes, we provide expert blockchain and Web3 consulting to help you choose the right technology stack and guide you through the development process, ensuring your project is future-proof.",
    },
    {
        id: 3,
        question: "Can you build custom blockchain solutions?",
        answer: "Absolutely! We specialize in custom blockchain development, creating secure, scalable applications that fit your specific needs, from decentralized apps (dApps) to smart contracts.",
    },
    {
        id: 4,
        question: "What services do you offer for the Metaverse and NFTs?",
        answer: "We create immersive Metaverse experiences and build robust NFT platforms. Whether you're launching a new NFT collection or designing a virtual world, we ensure seamless integration with blockchain technology.",
    },
    {
        id: 5,
        question: "Which blockchain technologies do you work with?",
        answer: "We work with leading blockchain platforms like Ethereum and Solana to deliver decentralized applications that are secure, scalable, and tailored to your business needs.",
    },
    {
        id: 6,
        question: "How do AI and blockchain work together in your solutions?",
        answer: "We combine the power of AI and blockchain to automate processes, enhance data analysis, and create smarter decentralized applications. This integration brings greater efficiency and security to your project.",
    },
    {
        id: 7,
        question: "Do you offer AI development services?",
        answer: "Yes, we offer a full range of AI development services, including AI agent development for various use cases, generative AI solutions, AI chatbot development, adaptive AI systems, AI integration, and AI consulting services.",
    },
    {
        id: 8,
        question:
            "What security measures do you take for blockchain and AI projects?",
        answer: "Security is our top priority. We ensure your blockchain and AI systems are protected with encryption, regular audits, and stringent testing so your solutions remain secure and reliable.",
    },
    {
        id: 9,
        question: "Where is your company based?",
        answer: "Our team operates globally, with a presence in India, the United States, Canada, the UAE, and the United Kingdom. We provide remote services to clients worldwide, ensuring smooth communication and support wherever you're located.",
    },
    {
        id: 10,
        question: "Do you offer post-launch support and maintenance?",
        answer: "Yes, we provide ongoing support and maintenance for blockchain, Web3, AI, and NFT projects, ensuring your solutions stay up-to-date with the latest technologies and perform optimally.",
    },
    {
        id: 11,
        question:
            "Which industries do you serve with your blockchain and AI solutions?",
        answer: "We work with industries such as finance, healthcare, e-commerce, gaming, and real estate, helping businesses integrate cutting-edge blockchain and AI technologies to stay ahead of the competition.",
    },
    {
        id: 12,
        question:
            "How long does it take to develop a blockchain or AI solution?",
        answer: "Development time depends on the complexity of the project. On average, blockchain and Web3 solutions take 3-6 months, while AI projects usually take around 2-5 months.",
    },
];
